import { injectable } from 'inversify-props';
import BaseService from '@/services/base-service';
import SettingsModel from '@/models/crm/settings.model';

const cacheTTLms = 5 * 60 * 1000; // 5 minutos

// Cache no escopo do módulo — compartilhado entre todas as instâncias do serviço.
// inflight evita race condition: chamadas simultâneas reutilizam a mesma Promise
// em vez de disparar múltiplas requisições ao backend.
let moduleCache: SettingsModel | null = null;
let moduleCacheTimestamp: number | null = null;
let inflight: Promise<SettingsModel> | null = null;

@injectable()
export default class SettingsService extends BaseService {
  async getSettings(): Promise<SettingsModel> {
    if (moduleCache && moduleCacheTimestamp && Date.now() - moduleCacheTimestamp < cacheTTLms) {
      return moduleCache;
    }
    if (inflight) {
      return inflight;
    }
    inflight = (this.httpService.get(SettingsModel, `${this.getApiPath()}/crm/settings`) as Promise<SettingsModel>)
      .then((result) => {
        // Se as settings mudaram no backend, invalida o cache automaticamente
        if (moduleCache && JSON.stringify(moduleCache) !== JSON.stringify(result)) {
          SettingsService.clearCache();
        }
        moduleCache = result;
        moduleCacheTimestamp = Date.now();
        inflight = null;
        return result;
      })
      .catch((err) => {
        inflight = null;
        throw err;
      });
    return inflight;
  }

  static clearCache(): void {
    moduleCache = null;
    moduleCacheTimestamp = null;
    inflight = null;
  }
}
